import React, { ErrorInfo } from "react";
import ReactDOMClient from "react-dom/client";
import singleSpaReact from "single-spa-react";
import { Provider } from "react-redux";
import { store } from "../../../store/store";
import UserGroups from "./UserGroups";

const errorBoundary = (err: Error, errInfo: ErrorInfo) => (
  <div style={{ color: "red", padding: "1rem" }}>
    <strong>UserGroups failed to load:</strong> {err.message}
  </div>
);

const UserGroupsParcelRoot: React.FC<any> = (props) => (
  <Provider store={store}>
    <UserGroups {...props} />
  </Provider>
);

const lifecycles = singleSpaReact({
  renderType: "createRoot",
  React,
  ReactDOMClient,
  rootComponent: UserGroupsParcelRoot,
  errorBoundary,
});

export const { bootstrap, mount, unmount } = lifecycles;
